var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",style:({'width': _vm.wd, 'height': _vm.ht, 'border-radius': _vm.br})},[_c('button',{style:({'border-radius': _vm.br, 'font-size': _vm.fz, 'color': _vm.cl}),attrs:{"value":_vm.val},on:{"click":function($event){return _vm.emitter(_vm.val)}}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2949ff82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseButton.vue
// module id = null
// module chunks = 